import { normalizeExplorerPath } from '@/lib/explorer-tree-focus'

/**
 * Solo personal workspace (invite auto-org or type=personal).
 * My documents (Workspace Desk under users/{slug}/) is for multi-member orgs
 * (ADR-0019 / Hop). On a personal workspace the desk path is empty and
 * redundant with Documents - hide that row.
 */
export function isPersonalWorkspace(workspace: {
  type?: string | null
  slug?: string | null
}): boolean {
  if (workspace.type === 'personal') return true
  const slug = (workspace.slug ?? '').trim().toLowerCase()
  return slug.startsWith('personal-')
}

/** Workspace Desk path for the current member: `{contentRoot}/users/{deskSlug}`. */
export function deskPathForMember(
  workspace: { contentRoot?: string | null },
  deskSlug: string | null | undefined,
): string {
  const root = (workspace.contentRoot ?? '').replace(/\/$/, '')
  const slug = (deskSlug ?? '').trim()
  if (!root || !slug) return ''
  return normalizeExplorerPath(`${root}/users/${slug}`)
}
